<div class="tile-for-reorder-product-item">
    <div class="tile-for-reorder-product-item__inner">
        <shared-common-item class="tile-for-reorder-product-item__item" [description]="description"
            [selectable]="selectable" [selected]="orderItem?._IsSelected"
            [subDescription]="orderItem?.SpecialInstructions" [edit]="false" [title]="title" [disabled]="disabled"
            [quantity]="orderItem?.Quantity" [total]="total" [bottomPadding]="bottomPadding"
            (onSelected)="handleSelected($event)" (onDeselected)="handleDeselected($event)">
        </shared-common-item>
    </div>
</div>
